import { StateCreator, create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { devtools, persist, subscribeWithSelector } from 'zustand/middleware';
import { createSelectors } from './createSelectors';
import { STORAGE_KEY } from '@/constants/keys';
import { IBusinessResponse } from '@/data/business/types';
import { MaybeType } from '@/types';

export type IBusinessState = {
  business: {
    selectBusiness: MaybeType<IBusinessResponse> | undefined;
    listBusiness: Array<IBusinessResponse>;
  };
  setSelectBusiness: (business: IBusinessResponse | undefined) => void;
  setListBusiness: (listBusiness: Array<IBusinessResponse>) => void;
};

const createBusinessSlice: StateCreator<
  IBusinessState,
  [['zustand/immer', never], ['zustand/devtools', unknown], ['zustand/subscribeWithSelector', never], ['zustand/persist', unknown]]
> = (set, get) => ({
  business: {
    selectBusiness: undefined,
    listBusiness: [],
  },
  setSelectBusiness: (business: IBusinessResponse | undefined) =>
    set(state => {
      state.business.selectBusiness = business;
    }),
  setListBusiness: (listBusiness: Array<IBusinessResponse>) =>
    set(state => {
      state.business.listBusiness = listBusiness;
    }),
});

export const useBusinessStore = createSelectors(
  create<IBusinessState>()(
    immer(
      devtools(
        subscribeWithSelector(
          persist(createBusinessSlice, {
            name: STORAGE_KEY.SELECT_BUSINESS,
          }),
        ),
        {
          enabled: false,
          name: STORAGE_KEY.SELECT_BUSINESS,
        },
      ),
    ),
  ),
);

export const useSelectedBusiness = () => {
  return useBusinessStore(state => state.business.selectBusiness);
};

export const useBusinessIDStore = () => {
  return useBusinessStore(state => state.business.selectBusiness?.id);
};
